export const CLIENT_NAME_MAX_LENGTH = 200;
export const CLIENT_ABBREVIATION_MAX_LENGTH = 10;
export const LOGO_MAX_SIZE_BYTES = 2 * 1024 * 1024;
